import React from "react";
import {
  FacebookShareButton,
  // TwitterShareButton,
  // LinkedinShareButton,
  WhatsappShareButton,
  // PinterestShareButton,
  FacebookIcon,
  // TwitterIcon,
  // LinkedinIcon,
  WhatsappIcon,
  // PinterestIcon,
} from "react-share";
import styled from "styled-components";

const SubShareCSS = styled.div`
  .network__share-button {
    display: inline-block;
    margin-right: 10px;
  }
  .network {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .hover {
    &:hover {
      opacity: 0.8;
    }
  }
  .transition--default {
    transition: opacity 0.3s ease;
  }
`;

const SubShare = ({ url = window.location.href, title = "Please visit PlusLife, to explore the potential of Health & Wellness", shareImage = " ", size = "2rem" }) => {
  return (
    <SubShareCSS>
      <ul className="share-list">
        <li className="network__share-button network cursor-pointer hover transition--default">
          <FacebookShareButton url={url} quote={title}>
            <FacebookIcon size={size} />
          </FacebookShareButton>
        </li>
        {/* <li className="network__share-button network cursor-pointer hover transition--default">
          <TwitterShareButton url={url} title={title}>
            <TwitterIcon size={size} />
          </TwitterShareButton>
        </li> */}
        <li className="network__share-button network cursor-pointer hover transition--default">
          <WhatsappShareButton url={url} title={title} separator=":: ">
            <WhatsappIcon size={size} />
          </WhatsappShareButton>
        </li>
        {/* <li className="network__share-button network cursor-pointer hover transition--default">
          <LinkedinShareButton url={url} title={title} windowWidth={750} windowHeight={600}>
            <LinkedinIcon size={size} />
          </LinkedinShareButton>
        </li> */}
        {/* comment if Pinterest integration is not working as expected in the future */}
        {/* <li className="network__share-button network cursor-pointer hover transition--default">
          <PinterestShareButton url={url} media={`${shareImage}`} windowWidth={1000} windowHeight={730}>
            <PinterestIcon size={size} />
          </PinterestShareButton>
        </li> */}
      </ul>
    </SubShareCSS>
  );
};

export default SubShare;
